<div>
  <ipo-flexible-table
    [dataSet]="multiPointData.data.hp"
    [columns]="columns | translateArray: (language$ | async)! : 'header'"
    [clickableRows]="true"
    (rowClicked)="openHpReportPage($event)"
  >
    <ng-template ipoTableColumn="addressColumn" let-hp>
      <div>
        {{ hp.properties.name }}
      </div>
    </ng-template>
    <ng-template ipoTableColumn="statusColumn" let-hp>
      <div>{{ setStatusString(hp) }}</div>
    </ng-template>
  </ipo-flexible-table>
</div>
